import BreadcrumbArea from '../../components/BreadcrumbArea/BreadcrumbArea';
import Layout from '../../layouts/Layout';
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { motion } from "framer-motion";
// import Certificates from './Certificates';
// import Certifications from './Project/ProjectAreaTwo';
// import Certifications from '../../components/Project/ProjectAreaTwo';
import CertificationSection from './CertificationSection';
import ExperenceOverview from './ExperienceOverview';

function ExperienceSection() {
  const timelineElements = [
    {
      title: "Junior Developer",
      location: "Surampalem, India",
      date: "2025 - Present",
      description: [
        "Developed responsive web applications using React.js and modern front-end technologies",
        "Collaborated with design and backend teams to implement user-focused features",
        "Improved application performance by 30% through code optimization and best practices"
      ],
    },
    {
      title: "Frontend Development Intern",
      location: "Surampalem, India",
      date: "2024 - 2025",
      description: [
        "Built interactive UIs using HTML5, CSS3, and JavaScript frameworks",
        "Implemented Redux for state management across complex application components",
        "Created secure authentication systems and responsive designs for cross-platform compatibility"
      ],
    },
    {
      title: "DSA Instructor Intern",
      location: "Surampalem, India",
      date: "2024 (Feb - June)",
      description: [
        "Led DSA training for 180+ engineering students with practical coding exercises",
        "Mentored 80 B.Tech students, resulting in 40% improved performance in technical assessments",
        "Designed problem-solving workshops focused on algorithmic efficiency and optimization"
      ],
    },
    {
      title: "AI/ML Trainee",
      location: "Surampalem, India",
      date: "2023 - 2024",
      description: [
        "Implemented ML models for classification and regression using Python, scikit-learn, and TensorFlow",
        "Developed neural networks for image recognition with 85% accuracy on test datasets",
        "Applied NLP techniques to build a sentiment analysis tool for customer feedback"
      ],
    }
  ];

  return (
    <div style={{ backgroundColor: "#292930" }}>
      <Layout header={1} footer={1} className="" mainClassName="">
        <BreadcrumbArea
          title={"Experience Details"}
          subtitle={"Experience"}
          className={"breadcrumb-area-two pt-175"}
          showShape={false}
        />
        <motion.div
          id="history"
          className="timeline-container"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "linear" }}
          viewport={{ once: true }}
        >
          <ExperenceOverview />
          <div className="items-container"  style={{marginTop : 50}}>
            {/* <h1 className="timeline-title">Experience</h1> */}
            <VerticalTimeline>
              {timelineElements.map((job, index) => (
                <VerticalTimelineElement
                  key={index}
                  className="vertical-timeline-element--work"
                  contentStyle={{ background: "#1D1D25", color: "#ffffff", }}
                  contentArrowStyle={{ borderRight: "7px solid #1D1D25" }}
                  date={job.date}
                  iconStyle={{ background: "white", color: "#1e1e28", boxShadow: "0px 0px 10px rgba(255, 186, 8, 0.5)" }}
                  icon={<img src="/Images/icons/thub.png" alt="Image" style={{ height: "100%", width: "100%", borderRadius: "50%" }} />}
                >
                  <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                    viewport={{ once: true }}
                  >
                    <h3 className="vertical-timeline-element-title" style={{ color: "orange" }}>{job.title}</h3>
                    <h4 className="vertical-timeline-element-subtitle" style={{ color: "whitesmoke", fontFamily :"cursive", fontWeight :"100" }}>{job.location}</h4>
                    <ul style={{ color: "white", paddingLeft: "20px" }}>
                      {job.description.map((point, idx) => (
                        <li key={idx} style={{ marginBottom: "10px" }}>{point}</li>
                      ))}
                    </ul>
                  </motion.div>
                </VerticalTimelineElement>
              ))}
            </VerticalTimeline>
          </div>
        </motion.div>
      <CertificationSection />
      </Layout>
    </div>
  );
}

export default ExperienceSection;